/* eslint-disable react-refresh/only-export-components -- Table config exports builder utilities, not React components. */
import type { ColumnsType } from "antd/es/table/interface";
import { buildColumns, renderDateCell, renderResolutionTagCell } from "./utils";
import type { TableRow } from "./issuesTableConfig";

const SEARCHABLE_COLUMNS = new Set([
  "discrepancy_rule_id",
  "discrepancy_rule_data_source",
  "discrepancy_rule_category",
  "discrepancy_rule_subcategory",
]);
const FIXED_COLUMNS = new Set(["discrepancy_rule_id"]);

export const RULES_COLUMN_ORDER = [
  "discrepancy_rule_id",
  "discrepancy_rule_level",
  "discrepancy_rule_data_source",
  "discrepancy_rule_type",
  "discrepancy_rule_category",
  "discrepancy_rule_subcategory",
  "discrepancy_rule_description",
  "discrepancy_rule_details",
  "discrepancy_rule_vivo_status",
] as const;

const TITLE_MAPPING = {
  discrepancy_rule_id: "Rule ID",
  discrepancy_rule_level: "Rule Level",
  discrepancy_rule_data_source: "Data Source",
  discrepancy_rule_type: "Rule Type",
  discrepancy_rule_category: "Rule Category",
  discrepancy_rule_subcategory: "Rule Subcategory",
  discrepancy_rule_description: "Rule Description",
  discrepancy_rule_details: "Rule Details",
  discrepancy_rule_vivo_status: "Vivo Status",
} satisfies Record<string, string>;

const COLUMN_WIDTHS = {
  DEFAULT: 170,
  discrepancy_rule_id: 130,
  discrepancy_rule_level: 140,
  discrepancy_rule_data_source: 180,
  discrepancy_rule_type: 140,
  discrepancy_rule_category: 220,
  discrepancy_rule_subcategory: 280,
  discrepancy_rule_description: 360,
  discrepancy_rule_details: 360,
  discrepancy_rule_vivo_status: 150,
} satisfies Record<string, number>;

const renderMap: Record<string, (text: unknown) => React.ReactNode> = {
  discrepancy_rule_vivo_status: renderResolutionTagCell,
  discrepancy_rule_last_modified_datetime: renderDateCell,
  discrepancy_rule_created_datetime: renderDateCell,
};

export const createRulesColumns = (rows: TableRow[]): ColumnsType<TableRow> => {
  return buildColumns({
    rows,
    columnOrder: RULES_COLUMN_ORDER,
    titleMapping: TITLE_MAPPING,
    columnWidths: COLUMN_WIDTHS,
    searchableColumns: SEARCHABLE_COLUMNS,
    fixedColumns: FIXED_COLUMNS,
    renderMap,
  }) as ColumnsType<TableRow>;
};
